<template>
  <div>
    <div>
      <WdsCollapse v-model:open="dailyRegistrationsToggle">
        <template #title>
          <p class="tw-font-semibold tw-flex tw-items-center">
            {{ $t('Daily time registrations') }}
            <WdsIcon
              class="tw-ml-2"
              :name="dailyRegistrationsToggle ? 'chevron-up' : 'chevron-down'"
              :size="16"
            />
          </p>
        </template>
        <template #content>
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t('Date') }}</th>
                <th>{{ rateType === 'daily' ? $t('Days') : $t('Hours') }}</th>
                <th>{{ $t('Description') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, key) in timesheetRows" :key="key">
                <td v-for="(col, colKey) in row" :key="colKey">
                  {{ col }}
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </WdsCollapse>
    </div>
    <div v-if="timesheetLines.length > 0" class="tw-mt-5">
      <WdsCollapse v-model:open="timesheetLinesToggle" data-test="timesheet-lines">
        <template #title>
          <p class="tw-font-semibold tw-flex tw-items-center">
            {{ $t('Timesheet lines summary') }}
            <WdsIcon
              class="tw-ml-2"
              :name="timesheetLinesToggle ? 'chevron-up' : 'chevron-down'"
              :size="16"
            />
          </p>
        </template>
        <template #content>
          <table class="table">
            <thead>
              <tr>
                <th class="tw-w-1/4">{{ $t('Timesheet line') }}</th>
                <th class="tw-w-1/4 text-end">
                  {{ rateType === 'daily' ? $t('Days') : $t('Hours') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(line, key) in timesheetLines" :key="key">
                <td>{{ line['field_values'] }}</td>
                <td class="text-end">
                  {{ line['hours'] }} {{ line['is_payable'] ? '' : `(${$t('non-payable')})` }}
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </WdsCollapse>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue'
import { WdsCollapse, WdsIcon } from '@worksome/wds-components'
import { $t } from '../../composables/translation'

const props = defineProps({
  rateType: {
    type: String,
    default: undefined,
  },
  timesheetRows: {
    type: Array,
    default: [],
  },
  timesheetLines: {
    type: Array,
    default: [],
  },
})

const dailyRegistrationsToggle = ref(false)
const timesheetLinesToggle = ref(true)

onMounted(() => {
  if (props.timesheetLines.length === 0) {
    dailyRegistrationsToggle.value = true
    timesheetLinesToggle.value = false
  }
})
</script>
